export default {
      id: "arms-usage",
      viewBox: "0 0 20 32",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#arms",
      toString: function () {
        return this.url;
      }
    }